module.exports = __webpack_public_path__ + "img/10n.4ccad051.png";